const mediaQuery = window.matchMedia("(max-width: 991.98px)");
function footerLinksCollapseable(e) {
  if (e.matches) {
    console.log("Media Query Matched!");
    $(".footer-collapseable-title").click(function () {
      $(this).next().slideToggle("fast").parent().toggleClass("active");
    });
  }
}
mediaQuery.addListener(footerLinksCollapseable);
footerLinksCollapseable(mediaQuery);

$(document).ready(function () {
  $(document).on("submit", ".Product-Grid--item .ProductForm", function (e) {
    e.preventDefault();
    var form = $(this);
    var action = form.attr("action");
    if (!action) {
      return;
    }
    $.ajax({
      type: "POST",
      url: action,
      cache: false,
      data: form.serialize(),
      beforeSend: function () {
        document.dispatchEvent(new CustomEvent("theme:loading:start")); // Then we add the product in Ajax
      },
      success: function (data) {
        document.dispatchEvent(new CustomEvent("theme:loading:end")); // Then we add the product in Ajax
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );

        if (!window.axios || !window.Shopify || !window.Shopify.routes) {
          return;
        }
        axios.get(window.Shopify.routes.root + "cart.js").then(function (e) {
          s(e.data);
        }).catch(function () {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        });
        var e = $(".cart-drawer"),
          t = $("[data-header-cart-toggle]"),
          a = $("#addToCartForm"),
          i = $("[data-add-to-cart]"),
          n = $("[data-close-cart]"),
          o = $("[data-addon-id]");
        function s(t) {
          if (!t || !t.items) {
            return;
          }
          var a = e.find("[data-cart-items]"),
            i = e.find(".cart-footer"),
            n = e.find("[data-cart-drawer-total]"),
            o = e.find("[data-cart-delivery]"),
            r = e.find("[data-cart-delivery-free]"),
            l = e.find("[data-shipping-progress]"),
            d = 39900;
          a.length && a.empty(),
            t.items.length
              ? (t.total_price < d
                  ? (r.hide(), o.show())
                  : (r.show(), o.hide()),
                i.show(),
                t.items.forEach(function (e, t) {
                  var o = "";
                  e.variant_title &&
                    (o = "<span>" + e.variant_title + "</span>");
                  var s =
                    '<div class="cart-items--item shadow"><div class="cart-items--item-image"><img src="' +
                    e.image +
                    '"></div><div class="cart-items--item-title">' +
                    e.product_title +
                    o +
                    '</div><div class="cart-items--item-price"><div class="quantity"><a href="#" class="change" data-update-qty="' +
                    e.key +
                    '" data-qty="' +
                    (e.quantity - 1) +
                    '"><svg width="24px" viewBox="0 0 24 24"><g fill="none"><path stroke="#323232" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16,12h-8"></path></g></svg></a><span class="qty">' +
                    e.quantity +
                    '</span><a href="#" class="change" data-update-qty="' +
                    e.key +
                    '" data-qty="' +
                    (e.quantity + 1) +
                    '"><svg width="24px" viewBox="0 0 24 24"><g fill="none"><path stroke="#323232" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12,8v8"></path><path stroke="#323232" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16,12h-8"></path></g></svg></a></div><span class="price"><span class="money" data-currency="' +
                    theme.currency +
                    '">' +
                    Shopify.formatMoney(
                      e.final_price,
                      theme.moneyFormat
                    ).replace(",00", "") +
                    '</span></span></div><div class="cart-items--item-remove" data-remove-item="' +
                    e.key +
                    '"><svg viewBox="0 0 24 24"><g fill="none"><path stroke="#323232" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8,8l8,8"></path><path stroke="#323232" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16,8l-8,8"></path></g></svg></div></div>';
                  a.append(s);
                }))
              : (l
                  .find(".shipping-progress--text")
                  .html(
                    theme.language.shipping_progress_html.replace(
                      "{{ amount }} 11",
                      Shopify.formatMoney(d - t.total_price, theme.moneyFormat)
                    )
                  ),
                setTimeout(function () {
                  l.find(".progress-bar")
                    .css("width", "0")
                    .removeClass("bg-success")
                    .addClass("bg-warning");
                }, 500),
                i.hide()),
            $(".cart-footer--total").on("DOMSubtreeModified", function () {
              var e = this;
              setTimeout(function () {
                var t = $(e).find(".money").last().text().replace(".", "");
                (t = 100 * parseInt(t)) < d
                  ? (l
                      .find(".shipping-progress--text")
                      .html(
                        theme.language.shipping_progress_html.replace(
                          "{{ amount }}",
                          Shopify.formatMoney(d - t, theme.moneyFormat)
                        )
                      ),
                    setTimeout(function () {
                      l.find(".progress-bar")
                        .css("width", (t / d) * 100 + "%")
                        .removeClass("bg-success")
                        .addClass("bg-warning");
                    }, 500))
                  : (l
                      .find(".shipping-progress--text")
                      .html(theme.language.free_shipping_achieved),
                    setTimeout(function () {
                      l.find(".progress-bar")
                        .css("width", "100%")
                        .removeClass("bg-warning")
                        .addClass("bg-success");
                    }, 500));
              }, 1e3);
            }),
            $("[data-header-cart-toggle] span").text(t.item_count),
            n.length && n.html(
              '<span class="money" data-currency="' +
                theme.currency +
                '">' +
                Shopify.formatMoney(t.total_price, theme.moneyFormat).replace(
                  ",00",
                  ""
                ) +
                "</span>"
            ),
            e.find("[data-update-qty]").on("click", function (e) {
              e.preventDefault();
              var t = $(this).data("update-qty"),
                a = $(this).data("qty");
              axios
                .post(window.Shopify.routes.root + "cart/change.js", {
                  id: t,
                  quantity: a,
                })
                .then(function (e) {
                  s(e.data);
                })
                .catch(function (e) {
                  alert((e.response && e.response.data && e.response.data.description) || "Der skete en fejl. Prøv igen.");
                });
            }),
            e.find("[data-remove-item]").on("click", function (e) {
              e.preventDefault();
              var t = $(this).data("remove-item");
              axios
                .post(window.Shopify.routes.root + "cart/change.js", {
                  id: t,
                  quantity: 0,
                })
                .then(function (e) {
                  s(e.data);
                })
                .catch(function (e) {
                  alert((e.response && e.response.data && e.response.data.description) || "Der skete en fejl. Prøv igen.");
                });
            });
        }

        $("[data-header-cart-toggle]").click();
      },
      error: function (e) {
        document.dispatchEvent(new CustomEvent("theme:loading:end")); // Then we add the product in Ajax
      },
    });
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  });
});
